<template>
  <main id="login" class="site-main vendor-login" :style="cssVars">
    <div class="grid-container">
      <div class="text-center" style="margin-bottom: 30px;">
        <a href="/">
          <img v-if="logo && logo.length > 0"
               :src="logo" style="max-width: 400px;">

          <h1 v-if="!logo || logo.length === 0"
              style="margin: 0;" v-html="logoTitle && logoTitle.length > 0 ? logoTitle : $store.state.portalSettings.name"></h1>
        </a>

        <div v-if="description && description.length > 0" v-html="description"
             style="padding-top: 30px;"></div>
      </div>

      <div class="login-form">
        <div class="panel" v-if="loginSection">
          <h2 v-if="title && title.length > 0" v-html="title"></h2>

          <div class="text-left">
            <div class="form-field">
              <label for="email">Email</label>
              <input id="email" name="email" type="email" @keyup.enter="login">
            </div>

            <div class="form-field">
              <label for="password">Password</label>
              <input id="password" type="password" name="password" @keyup.enter="login">
            </div>

            <p class="text-success-color text-right"
               v-if="loginSuccess !== null" v-html="loginSuccess"></p>

            <p class="text-alert-color text-right"
               v-if="loginError !== null" v-html="loginError"></p>

            <button class="button--wide" type="submit" @click="login">Login</button>

            <div class="text-center" style="padding: 15px;">
              <a @click="showRegister">Register</a> |
              <a @click="showForgotPassword">Forgot your password?</a>
            </div>
          </div>
        </div>

        <div class="panel" v-if="registerSection">
          <h2>Register for an Account</h2>

          <div class="text-left">
            <div v-if="registerSuccess === null" style="margin-bottom: 20px;">
              <div class="form-field">
                <label for="register-name" v-if="$store.state.portalSettings.myshopify_domain === 'sciencegrit.myshopify.com'">User Name</label>
                <label for="register-name" v-else>Name</label>
                <input id="register-name" name="register-name" type="text">
              </div>

              <div class="form-field">
                <label for="register-email">Email</label>
                <input id="register-email" name="register-email" type="email">
              </div>

              <div class="form-field" v-if="$store.state.portalSettings.myshopify_domain === 'fallingout.myshopify.com'">
                <label for="register-paypal-email">PayPal Email <br><i><small style="font-weight: 400;">Account to receive payments to.</small></i></label>
                <input id="register-paypal-email" name="register-paypal-email" type="email">
              </div>

              <div class="form-field">
                <label for="register-password">Password</label>
                <input id="register-password" type="password" name="register-password">
              </div>

              <div class="form-field">
                <label for="register-confirm-password">Confirm Password</label>
                <input id="register-confirm-password" type="password"
                       name="register-confirm-password">
              </div>

              <div class="form-field" v-if="terms !== undefined && terms.length > 0">
                <label for="register-terms">
                  <input id="register-terms" type="checkbox" name="register-terms">
                  <span v-if="$store.state.portalSettings.myshopify_domain === 'sciencegrit.myshopify.com'">I accept the <a :href="terms" target="_blank" @click="confirmedTerms = true">ScienceGrit Artist Partnership Agreement.</a></span>
                  <span v-else>
                      <span v-if="$store.state.portalSettings.myshopify_domain === 'lalisimone.myshopify.com'">Click on the <a :href="terms" target="_blank" @click="confirmedTerms = true" style="text-decoration: underline;">terms & conditions</a> link to read the terms. Then check the box on this page to accept.</span>
                      <span v-else>I accept the <a :href="terms" target="_blank" @click="confirmedTerms = true">terms & conditions.</a></span>
                  </span>
                </label>
              </div>

              <div class="form-field" v-if="$store.state.portalSettings.myshopify_domain === 'fallingout.myshopify.com'">
                <label for="register-donate">
                  <input id="register-donate" type="checkbox" name="register-donate">
                  <span class="text-alert-color">ATTENTION!</span> Please only check this box if you
                  wish to donate your commission fees to
                  <a href="https://welcomefuturekids.com/pages/moms-for-moms"
                     target="_blank">Moms for Moms</a>
                </label>
              </div>
            </div>

            <p class="text-alert-color text-right"
               v-if="registerError !== null" v-html="registerError"></p>

            <button class="button--wide" type="submit" @click="register"
                    v-if="registerSuccess === null">Register</button>

            <p class="text-success-color text-center"
               v-if="registerSuccess !== null" v-html="registerSuccess"></p>

            <div class="text-center" style="padding: 15px;">
              <a @click="showLogin">Back to Login</a>
            </div>
          </div>
        </div>

        <div class="panel" v-if="forgotPasswordSection">
          <h2>Forget your password?</h2>

          <div class="text-left">
            <div class="form-field">
              <label for="reset-email">Email</label>
              <input id="reset-email" name="reset-email" type="email">
            </div>

            <p class="text-success-color text-right"
               v-if="passwordSuccess !== null" v-html="passwordSuccess"></p>

            <p class="text-alert-color text-right"
               v-if="passwordError !== null" v-html="passwordError"></p>

            <button class="button--wide"
                    @click="resetPassword">Request Password Reset</button>

            <div class="text-center" style="padding: 15px;">
              <a @click="showLogin">Back to Login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import authenticationMixin from '@/mixins/authentication'
import axios from 'axios'
import env from '@/mixins/env'

export default {
  name: 'vendorPortalLogin',
  mixins: [authenticationMixin],
  components: {},
  data: function () {
    return {
      logo: '',
      logoTitle: '',
      description: '',
      title: 'Welcome Vendors',
      terms: '',
      confirmedTerms: false,
      loginSection: true,
      registerSection: false,
      forgotPasswordSection: false,
      loginSuccess: null,
      loginError: null,
      registerSuccess: null,
      registerError: null,
      passwordSuccess: null,
      passwordError: null
    }
  },
  computed: {
    fontColor () {
      let color = '#333333'

      if (this.$store.state.portalSettings.vendor_portal_theme !== 'light') {
        color = '#ffffff'
      }

      if (this.getPortalColor('vendor_portal_font_color') !== false) {
        color = this.getPortalColor('vendor_portal_font_color')
      }

      return color
    },
    cssVars () {
      return {
        '--font-color': this.fontColor
      }
    }
  },
  methods: {
    getPortalColor (key) {
      if (this.$store.state.portalSettings !== null) {
        if (this.$store.state.portalSettings[key] && this.$store.state.portalSettings[key].length === 7) {
          return this.$store.state.portalSettings[key]
        }
      }

      return false
    },
    showLogin () {
      this.loginSection = true
      this.registerSection = false
      this.forgotPasswordSection = false
    },
    showRegister () {
      this.loginSection = false
      this.registerSection = true
      this.forgotPasswordSection = false
    },
    showForgotPassword () {
      this.loginSection = false
      this.registerSection = false
      this.forgotPasswordSection = true
    },
    login () {
      const emailElement = document.getElementById('email')
      const passwordElement = document.getElementById('password')

      let data = {
        email: emailElement.value.trim(),
        password: passwordElement.value.trim()
      }

      let params = env.params().split('&')

      for (let i = 0; i < params.length; i++) {
        let param = params[i].split('=')

        if (param[0] !== 'email') {
          data[param[0]] = param[1]
        }
      }

      axios({
        method: 'post',
        url: env.api_url() + '/vendors/login/',
        data: data
      }).then((response) => {
        if (response.status === 200) {
          if (response.data.refresh !== undefined) {
            let expireTime = new Date()

            expireTime.setMinutes(expireTime.getMinutes() + 5)

            this.$store.state.token = {
              'token': response.data.access,
              'expire': expireTime
            }

            this.$store.state.refreshToken = response.data.refresh

            window.$cookies.set('va-token', this.$store.state.token)
            window.$cookies.set('va-refresh-token', this.$store.state.refreshToken)

            this.$store.dispatch('loadVendor')

            this.$router.push('/apps/vendor-portal/?' + env.params())
          }

          if (response.data.message !== undefined) {
            this.loginError = response.data.message
          } else {
            this.loginError = 'Something went wrong. Please try again.'
          }
        }
      }).catch(error => {
        if (error) {
          this.loginError = 'Something went wrong. Please try again.'
        }
      })
    },
    register () {
      let nameElement = document.getElementById('register-name')
      let emailElement = document.getElementById('register-email')
      let passwordElement = document.getElementById('register-password')
      let confirmPasswordElement = document.getElementById('register-confirm-password')
      let termsElement = document.getElementById('register-terms')

      nameElement.style.borderColor = 'transparent'
      emailElement.style.borderColor = 'transparent'
      passwordElement.style.borderColor = 'transparent'
      confirmPasswordElement.style.borderColor = 'transparent'

      if (nameElement.value.length === 0) {
        nameElement.style.borderColor = '#cc4b37'
      }

      if (emailElement.value.length === 0) {
        emailElement.style.borderColor = '#cc4b37'
      }

      if (passwordElement.value.length === 0) {
        passwordElement.style.borderColor = '#cc4b37'
      }

      if (confirmPasswordElement.value.length === 0) {
        confirmPasswordElement.style.borderColor = '#cc4b37'
      }

      if (passwordElement.value.length === 0 || confirmPasswordElement.value.length === 0 || nameElement.value.length === 0 || emailElement.value.length === 0) {
        this.registerError = 'Please fill out all fields.'

        return true
      }

      if (passwordElement.value !== confirmPasswordElement.value) {
        this.registerError = 'New and confirm passwords do not match.'

        return true
      }

      if (this.terms !== undefined && this.terms.length > 0) {
        if (!this.confirmedTerms) {
          this.registerError = 'You must click and read the terms & conditions.'

          return true
        }

        if (!termsElement.checked) {
          this.registerError = 'You must accept the terms & conditions.'

          return true
        }
      }

      let params = env.params().split('&')
      let data = {}

      for (let i = 0; i < params.length; i++) {
        let param = params[i].split('=')

        data[param[0]] = param[1]
      }

      data['name'] = nameElement.value.trim()
      data['email'] = emailElement.value.trim()
      data['password1'] = passwordElement.value
      data['password2'] = confirmPasswordElement.value
      data['myshopify_domain'] = this.$store.state.portalSettings.myshopify_domain.trim()

      if (this.$store.state.portalSettings.myshopify_domain === 'fallingout.myshopify.com') {
        let paypalEmailElement = document.getElementById('register-paypal-email')
        let donateElement = document.getElementById('register-donate')

        if (donateElement.checked) {
          data['donate'] = true
        } else {
          data['donate'] = false
          data['paypal_email'] = paypalEmailElement.value.trim()
        }
      }

      this.registerSuccess = null
      this.registerError = null

      axios({
        method: 'post',
        url: env.api_url() + '/accounts/vendor-register/',
        data: data
      }).then((response) => {
        if (response.status === 200) {
          if (this.$store.state.portalSettings.myshopify_domain === 'specialguestapp.myshopify.com') {
            this.registerSuccess = 'Thanks for registering. A member of our team must approve your account. Please allow up to 24 hours before logging back into your account.'
          } else {
            this.registerSuccess = 'Account has been created. Please wait for ' +
              'the store owner to associate your account to your sales.'
          }
        } else {
          this.registerError = 'Email already exists. If you do not know your password please use "Forgot your Password?".'
        }
      }).catch(error => {
        if (error) {
          this.registerError = 'Email already exists. If you do not know your password please use "Forgot your Password?".'
        }
      })
    },
    resetPassword () {
      const emailElement = document.getElementById('reset-email')

      if (emailElement.value.length === 0) {
        emailElement.style.borderColor = '#cc4b37'
      }

      let data = {
        email: emailElement.value
      }

      let params = env.params().split('&')

      for (let i = 0; i < params.length; i++) {
        let param = params[i].split('=')

        if (param[0] !== 'email') {
          data[param[0]] = param[1]
        }
      }

      this.passwordSuccess = null
      this.passwordError = null

      axios({
        method: 'put',
        url: env.api_url() + '/accounts/vendor-send-reset-pw-email/',
        data: data
      }).then((response) => {
        if (response.status === 200) {
          this.passwordSuccess = 'Password reset email has been sent.'
        } else {
          this.passwordError = 'Invalid email.'
        }
      }).catch(error => {
        if (error) {
          this.passwordError = 'Invalid email.'
        }
      })
    }
  },
  created () {
    this.logo = this.$store.state.portalSettings.vendor_portal_logo_url
    this.logoTitle = this.$store.state.portalSettings.vendor_portal_logo_title
    this.description = this.$store.state.portalSettings.vendor_portal_login_description
    this.title = this.$store.state.portalSettings.vendor_portal_login_title
    this.terms = this.$store.state.portalSettings.vendor_portal_terms

    let currentURL = (document.URL)

    let params = currentURL.split('?')[1]

    if (params !== undefined) {
      if (params.indexOf('register=1') > -1) {
        this.loginSection = false
        this.registerSection = true

        setTimeout(function () {
          let nameElement = document.getElementById('register-name')
          let emailElement = document.getElementById('register-email')

          let email = params
          let name = params

          email = email.split('email=')[1].split('&')[0]
          name = name.split('name=')[1].split('&')[0]

          nameElement.value = decodeURI(name)
          emailElement.value = decodeURI(email.replace('%40', '@'))
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

.vendor-login {
  padding: 60px 0;

  color: var(--font-color);
}

.login-form {
  text-align: center;

  .panel {
    margin: 0 auto;
    max-width: 500px;

    h2,
    label {
      color: var(--font-color);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/login.vue